/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface FormateurLocalisationContratSearch
 */
export interface FormateurLocalisationContratSearch {
    /**
     * 
     * @type {number}
     * @memberof FormateurLocalisationContratSearch
     */
    idformateur?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormateurLocalisationContratSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof FormateurLocalisationContratSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof FormateurLocalisationContratSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FormateurLocalisationContratSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof FormateurLocalisationContratSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof FormateurLocalisationContratSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the FormateurLocalisationContratSearch interface.
 */
export function instanceOfFormateurLocalisationContratSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FormateurLocalisationContratSearchFromJSON(json: any): FormateurLocalisationContratSearch {
    return FormateurLocalisationContratSearchFromJSONTyped(json, false);
}

export function FormateurLocalisationContratSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormateurLocalisationContratSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idformateur': !exists(json, 'idformateur') ? undefined : json['idformateur'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function FormateurLocalisationContratSearchToJSON(value?: FormateurLocalisationContratSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idformateur': value.idformateur,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

